<div class="workSpace">
  <!-- Titulo -->
  <div class="w3-container w3-container-template headersTab">
    <!--Titulo de modulo y subtitulo-->
    <div class="w3-caja-menu padreizquierda">
      <div class="w3-row hijoizquierda centradoVertical">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ 'menu.'+dataService.moduleSelect | translate }} </b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect | translate }} </span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-margin-left-filter w3-subtituloPrincipal"> {{ plantilla ? plantilla.nombreInst : '' }} </span>
      </div>
    </div>
  </div>
  <!-- TABLERO -->
  <div class="w3-row workSpaceTab" style="display: flex; justify-content: center; align-items: center;">
    <div class="w3-row">
      <div class="w3-row" style="margin-bottom: 7px;">
        @if(plantilla){
          <div class="w3-veinte" style="width: 20px; margin-top: 2px;">
            <mat-icon class="iconoMen" matTooltip="{{'proyFinanciera.configCatalogo.configPlantilla' | translate}}" [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="plantConf">settings</mat-icon>
            <mat-menu #plantConf="matMenu">
              <button mat-menu-item (click)="modalPlantilla(true)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">edit</mat-icon>
                <span>{{'proyFinanciera.configCatalogo.editPlanti' | translate}}</span>
              </button>
              @if(eliminar){
                <button mat-menu-item (click)="eliminarPlantilla()">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">delete</mat-icon>
                  <span>{{'proyFinanciera.configCatalogo.eliminarPlanti' | translate}}</span>
                </button>
              }            
            </mat-menu>
          </div>
        }  
        @if(plantilla){
          <div class="w3-veinte w3-center" style="width: fit-content; margin-left: 5px;">
            <span class="status-badge" [ngClass]="plantilla.activo ? 'activo' : 'inactivo'">
              {{ plantilla.activo ? 'Activa' : 'Inactiva' }}
            </span>
          </div>          
        }              
        <div class="w3-half">
          <app-select-title
            [options]="dataPlantillas"
            [placeholder]="'proyFinanciera.configCatalogo.selecPlanti'"
            displayKey="nombre"
            (selectedChange)="selectPlantilla($event)"       
          ></app-select-title>
        </div>        
        <div class="w3-rest w3-right">
          <div class="w3-row colorBotonDeNuevo w3-right" (click)="modalPlantilla()">
            {{'proyFinanciera.configCatalogo.nuevaPlanti' | translate}}
            <mat-icon class="iconoMen">add_circle_outline</mat-icon>
          </div>         
        </div>
      </div>
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" color="warn" style="height: 80vh;">
        <!-- CONFIGURACION CONTABLE -->
        <mat-tab label="{{'proyFinanciera.configCatalogo.enc1' | translate}}">
          <div class="w3-white conteTabla">
            <div class="w3-row" [ngClass]="{'w3-disabled': !plantilla}">
              @if (!dataExistente.contable) {
                <div class="w3-row colorBotonDeNuevo" style="margin-left: 5vh; " (click)="cargarArchivo('Contable')">
                  {{'proyFinanciera.configCatalogo.agregarArch' | translate}}
                  <mat-icon class="iconoMen">add_circle_outline</mat-icon>
                </div>
                <div class="w3-row colorBotonDeNuevo" style="margin-left: 5vh;" (click)="agregarContable()">
                  {{'proyFinanciera.configCatalogo.agregarEle' | translate}}
                  <mat-icon class="iconoMen">add_circle_outline</mat-icon>
                </div>
              }@else{
                <div class="w3-quarter">
                  @if(editarCuentas){
                    <div class="w3-row colorBotonDeNuevo" style="margin-left: 5vh;" (click)="agregarContable()">
                      {{'proyFinanciera.configCatalogo.agregarEle' | translate}}
                      <mat-icon class="iconoMen">add_circle_outline</mat-icon>
                    </div>
                  }
                </div>
                
              }
              <div class="w3-rest w3-right">
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menuGB">more_vert</mat-icon>
              </div>
              <mat-menu #menuGB="matMenu" xPosition="before">
                <button mat-menu-item (click)="exportar(1)">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">description</mat-icon>
                  <span>{{'menu.Exportar' | translate}}</span>
                </button>
              </mat-menu>
            </div>
            <div class="w3-scroll" style="height: 88%; margin-bottom: 1%;">
              <table class="w3-table">
                <thead>
                  <tr class="w3-table-titleLow w3-center">
                    <th class="w3-border-right-balance marginsH stikyColum" style="width: 50px;"> {{'proyFinanciera.configCatalogo.titTab1' | translate}} </th>
                    <th class="w3-border-right-balance marginsH stikyColum" style="width: 50px;"> {{'proyFinanciera.configCatalogo.titTab2' | translate}} </th>
                    <th class="w3-border-right-balance marginsH stikyColum" style="width: 100px;"> {{'proyFinanciera.configCatalogo.titTab3' | translate}} </th>
                    <th class="w3-border-right-balance marginsH stikyColum" style="width: 40vw;"> {{'proyFinanciera.configCatalogo.titTab4' | translate}} </th>
                    <th class="w3-border-right-balance marginsH stikyColum"> {{'proyFinanciera.configCatalogo.titTab5' | translate}} </th>
                    <th class="w3-border-right-balance marginsH stikyColum"> {{'proyFinanciera.configCatalogo.titTab6' | translate}} </th>
                    @if (!dataExistente.contable || editarCuentas) {<th class="w3-border-right-balance marginsH stikyColum">  </th>}                    
                  </tr>
                </thead>
                @for (r of dataContable; track r; let i = $index) {
                  <tbody>
                    <tr class="w3-table-trtd">
                      <td class="borderAllLow marginsH">
                        <input [(ngModel)]="r.nivel" (ngModelChange)="editarCuenta(r)" matInput type="number" class="inputPon alinRight" [readonly]="!editarCuentas"
                         [matTooltip]="editarCuentas ? ('acciones.editar' | translate) : ''" [ngStyle]="{cursor: editarCuentas ? 'text' : 'default'}">
                      </td>
                      <td class="borderAllLow marginsH">
                        <select [(ngModel)]="r.tipoCuenta" (ngModelChange)="editarCuenta(r)" class="select-sin-estilo" [disabled]="!editarCuentas" 
                          [matTooltip]="editarCuentas ? ('acciones.editar' | translate) : ''" [ngStyle]="{cursor: editarCuentas ? 'text' : 'default'}"> 
                          <option value="" disabled selected></option> 
                          @for(i of catTipo; track $index){
                            <option value="{{i.clave}}">{{i.clave}}</option>
                          }                       
                        </select>
                      </td>
                      <td class="borderAllLow marginsH">
                        <input [(ngModel)]="r.codigo" (ngModelChange)="editarCuenta(r)" matInput type="number" class="inputPon alinRight" [readonly]="!editarCuentas"
                         [matTooltip]="editarCuentas ? ('acciones.editar' | translate) : ''" [ngStyle]="{cursor: editarCuentas ? 'text' : 'default'}">
                      </td>
                      <td class="borderAllLow marginsH" matTooltip="{{'acciones.editar' | translate}}">
                        <input [(ngModel)]="r.nombre" (ngModelChange)="editarCuenta(r)" matInput type="text" class="inputPon alinLeft">
                      </td>
                      <td class="borderAllLow marginsH w3-center" matTooltip="{{'acciones.editar' | translate}}">
                        <select [(ngModel)]="r.proyeccion" (ngModelChange)="editarCuenta(r)" class="select-sin-estilo"> 
                          <option value="" disabled selected></option> 
                          <option value="SI">SI</option> 
                          <option value="NO">NO</option>                           
                        </select>
                      </td>
                      <td class="borderAllLow marginsH" matTooltip="{{'acciones.editar' | translate}}">
                        <input [(ngModel)]="r.segmento" (ngModelChange)="editarCuenta(r)" matInput type="text" class="inputPon w3-center">
                      </td>
                      @if (!dataExistente.contable || editarCuentas) {
                        <td class="borderAllLow marginsH">
                          <mat-icon class="iconoMen material-icons-outlined" matTooltip="{{'menu.eliminar' | translate}}" (click)="eliminarContable(i)">delete</mat-icon>
                        </td>
                      }                      
                    </tr>
                  </tbody>
                }
              </table>
              <!-- TODO revisar la logica cuando [] -->
              @if (dataContable.length === 0 && !dataCargando) {
                <div class="w3-row w3-center" style="margin-top: 3vh;">{{'proyFinanciera.configCatalogo.confVacia' | translate}}</div>
              }@else {
                <div class="preview-background" style="margin-top: 15px;">
                  <div class="page">
                    <ngx-skeleton-loader count="5" [theme]="{ 
                      'border-radius': '10px',
                      height: '2vh',
                      width: '70vw',
                    }" />
                    <ngx-skeleton-loader [theme]="{ 
                      'border-radius': '15px',
                      height: '25vh',
                      width: '88vw',
                    }" />
                  </div>
                </div>
              } 
            </div>
            <div class="w3-row">
              @if (dataContable.length !== 0 && newContable) {
                <div class="w3-right">
                  <button mat-flat-button color="success" style="height: 3vh; width: 100%;" (click)="guardarDataContable('contable')">{{'acciones.guard' | translate}}</button>
                </div>
              }              
            </div>
          </div>           
        </mat-tab>
        <!-- CONFIGURACION EXTRACONTABLE -->
        <mat-tab label="{{'proyFinanciera.configCatalogo.enc2' | translate}}">
          <div class="w3-white conteTabla">
            <div class="w3-row">
              @if (!dataExistente.extra) {
                <div class="w3-row" [ngClass]="{'w3-disabled': !plantilla}">
                  <div class="w3-row colorBotonDeNuevo" style="margin-left: 5vh; " (click)="cargarArchivo('Extracontable')">
                    {{'proyFinanciera.configCatalogo.agregarArch' | translate}}
                    <mat-icon class="iconoMen">add_circle_outline</mat-icon>
                  </div>
                  <div class="w3-row colorBotonDeNuevo" style="margin-left: 5vh;" (click)="agregarExtracontable()">
                    {{'proyFinanciera.configCatalogo.agregarEle' | translate}}
                    <mat-icon class="iconoMen">add_circle_outline</mat-icon>
                  </div>
                </div>
              }@else {
                <div class="w3-quarter">
                  @if(editarCuentas){
                    <div class="w3-row colorBotonDeNuevo" style="margin-left: 5vh;" (click)="agregarExtracontable()">
                      {{'proyFinanciera.configCatalogo.agregarEle' | translate}}
                      <mat-icon class="iconoMen">add_circle_outline</mat-icon>
                    </div>
                  }
                </div>
                
              }
              <div class="w3-rest w3-right">
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menuGB2">more_vert</mat-icon>
              </div>
              <mat-menu #menuGB2="matMenu" xPosition="before">
                <button mat-menu-item (click)="exportar(2)">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">description</mat-icon>
                  <span>{{'menu.Exportar' | translate}}</span>
                </button>
              </mat-menu>
            </div>
            
            <div class="w3-scroll" style="height: 88%; margin-bottom: 1%;">
              <table class="w3-table">
                <thead>
                  <tr class="w3-table-titleLow w3-center">
                    <th class="w3-border-right-balance marginsH stikyColum"> {{'proyFinanciera.configCatalogo.titTab2' | translate}} </th>
                    <th class="w3-border-right-balance marginsH stikyColum"> {{'proyFinanciera.configCatalogo.titTab3' | translate}} </th>
                    <th class="w3-border-right-balance marginsH stikyColum"> {{'proyFinanciera.configCatalogo.titTab4' | translate}} </th>
                    <th class="w3-border-right-balance marginsH stikyColum"> {{'proyFinanciera.configCatalogo.titTab5' | translate}} </th>
                    @if(!dataExistente.extra && editarCuentas) {<th class="w3-border-right-balance marginsH stikyColum">  </th>}
                  </tr>
                </thead>
                @for (r of dataExtraCon; track r; let i = $index) {
                  <tbody>
                    <tr class="w3-table-trtd">
                      <td class="borderAllLow marginsH">
                        <input [(ngModel)]="r.tipoCuenta" (ngModelChange)="editarCuenta(r)" matInput type="text" class="inputPon w3-center mayus" [readonly]="!editarCuentas"
                         [matTooltip]="editarCuentas ? ('acciones.editar' | translate) : ''" [ngStyle]="{cursor: editarCuentas ? 'text' : 'default'}">
                      </td>
                      <td class="borderAllLow marginsH">
                        <input [(ngModel)]="r.codigo" (ngModelChange)="editarCuenta(r)" matInput type="number" class="inputPon alinRight" [readonly]="!editarCuentas"
                         [matTooltip]="editarCuentas ? ('acciones.editar' | translate) : ''" [ngStyle]="{cursor: editarCuentas ? 'text' : 'default'}">
                      </td>
                      <td class="borderAllLow marginsH">
                        <input [(ngModel)]="r.nombre" (ngModelChange)="editarCuenta(r)" matInput type="text" class="inputPon alinLeft">
                      </td>
                      <td class="borderAllLow marginsH w3-center">
                        <select [(ngModel)]="r.proyeccion" (ngModelChange)="editarCuenta(r)" class="select-sin-estilo"> 
                          <option value="" disabled selected></option> 
                          <option value="SI">SI</option> 
                          <option value="NO">NO</option>                           
                        </select>
                      </td>
                      @if (!dataExistente.extra && editarCuentas) {
                        <td class="borderAllLow marginsH">
                          <mat-icon class="iconoMen material-icons-outlined" matTooltip="{{'menu.eliminar' | translate}}" (click)="eliminarExtracontable(i)">delete</mat-icon>
                        </td>
                      }                      
                    </tr>
                  </tbody>
                }
              </table>
              @if (dataExtraCon.length === 0) {
                <div class="w3-row w3-center" style="margin-top: 3vh;">{{'proyFinanciera.configCatalogo.confVacia' | translate}}</div>
              }
            </div>
            <div class="w3-row">
              @if (dataExtraCon.length !== 0 && newExtracon) {
                <div class="w3-right">
                  <button mat-flat-button color="success" style="height: 3vh; width: 100%;" (click)="guardarDataContable('extra')">{{'acciones.guard' | translate}}</button>
                </div>
              }              
            </div>
          </div>     
        </mat-tab>
        <!-- CONFIGURACION SUCURSALES -->
        <mat-tab label="{{'proyFinanciera.configCatalogo.enc3' | translate}}">
          <div class="w3-white conteTabla">
            <div class="w3-row" [ngClass]="{'w3-disabled': !plantilla}">
              @if(!dataExistente.suc){
                <div class="w3-row colorBotonDeNuevo" style="margin-left: 5vh; " (click)="cargarArchivo('Sucursales')">
                  {{'proyFinanciera.configCatalogo.agregarArch' | translate}}
                  <mat-icon class="iconoMen">add_circle_outline</mat-icon>
                </div>
              }
              <div class="w3-row colorBotonDeNuevo" style="margin-left: 5vh;" (click)="agregarSucursal()">
                {{'proyFinanciera.configCatalogo.agregarEle2' | translate}}
                <mat-icon class="iconoMen">add_circle_outline</mat-icon>
              </div>
              <div class="w3-rest w3-right">
                  <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menuGB3">more_vert</mat-icon>
                </div>
                <mat-menu #menuGB3="matMenu" xPosition="before">
                  <button mat-menu-item (click)="exportar(3)">
                    <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">description</mat-icon>
                    <span>{{'menu.Exportar' | translate}}</span>
                  </button>
                </mat-menu>
            </div>
                        
            <div class="w3-scroll" style="height: 88%; margin-bottom: 1%;">
              <table class="w3-table">
                <thead>
                  <tr class="w3-table-titleLow w3-center">
                    <th class="w3-border-right-balance marginsH stikyColum"> {{'proyFinanciera.configCatalogo.titTab3' | translate}} </th>
                    <th class="w3-border-right-balance marginsH stikyColum"> {{'proyFinanciera.configCatalogo.titTab8' | translate}} </th>
                    @if(!dataExistente.suc){<th class="w3-border-right-balance marginsH stikyColum">  </th>}
                  </tr>
                </thead>
                @for (r of dataSucursales; track r; let i = $index) {
                  <tbody>
                    @if(r.nombre !== 'Consolidado'){
                      <tr class="w3-table-trtd">
                        <td class="borderAllLow marginsH">
                          <input [(ngModel)]="r.codigo" (ngModelChange)="editarSucursal(r)" matInput type="number" class="inputPon alinRight">
                        </td>
                        <td class="borderAllLow marginsH">
                          <input [(ngModel)]="r.nombre" (ngModelChange)="editarSucursal(r)" matInput type="text" class="inputPon alinLeft">
                        </td> 
                        @if(!dataExistente.suc){
                          <td class="borderAllLow marginsH">
                            <mat-icon class="iconoMen material-icons-outlined" matTooltip="{{'menu.eliminar' | translate}}" (click)="eliminarSucursal(i)">delete</mat-icon>
                          </td>
                        }                      
                      </tr>
                    }                    
                  </tbody>
                }
              </table>
              @if (dataSucursales.length === 0) {
                <div class="w3-row w3-center" style="margin-top: 3vh;">{{'proyFinanciera.configCatalogo.confVacia' | translate}}</div>
              }
            </div>
            <div class="w3-row">
              @if (dataSucursales.length !== 0 && newSucursales) {
                <div class="w3-right">
                  <button mat-flat-button color="success" style="height: 3vh; width: 100%;" (click)="postDataSucursal()">{{'acciones.guard' | translate}}</button>
                </div>
              }              
            </div>
          </div>   
        </mat-tab>
        @if(dataExistente.contable || dataExistente.extra){
          <!-- Lista Validaciones -->
          <mat-tab label="{{'proyFinanciera.configCatalogo.enc4' | translate}}">
            <div class="w3-white conteTabla">
              <div class="w3-row" [ngClass]="{'w3-disabled': !plantilla}">
                <div class="w3-row colorBotonDeNuevo " style="margin-right: 25px;" (click)="modalValidacion()">
                  {{'proyFinanciera.configCatalogo.addValidacion' | translate}}
                  <mat-icon class="iconoMen">add_circle_outline</mat-icon>
                </div>
              </div>
              <div class="w3-scroll" style="height: 88%; margin-bottom: 1%;">
                <table class="w3-table">
                  <thead>
                    <tr class="w3-table-titleLow w3-center">
                      <th class="w3-border-right-balance marginsH stikyColum"> {{'proyFinanciera.configCatalogo.titNombre' | translate}} </th>
                      <th class="w3-border-right-balance marginsH stikyColum"> {{'proyFinanciera.configCatalogo.expresion' | translate}} </th>
                      <th class="w3-border-right-balance marginsH stikyColum">  </th>
                    </tr>
                  </thead>
                  @for (r of dataValidaciones; track r; let i = $index) {
                    <tbody>
                      <tr class="w3-table-trtd">
                        <td class="borderAllLow marginsH">{{r.description}}
                        </td>
                        <td class="borderAllLow marginsH">{{r.expresion}}
                        </td> 
                        <td class="borderAllLow marginsH w3-center">
                          <mat-icon class="iconoMen material-icons-outlined" matTooltip="{{'menu.edit' | translate}}" (click)="opcionesValidacion('edit',r)">edit</mat-icon>
                          <mat-icon class="iconoMen material-icons-outlined" matTooltip="{{'menu.eliminar' | translate}}" (click)="opcionesValidacion('delete',r)">delete</mat-icon>
                        </td>
                      </tr>                
                    </tbody>
                  }
                </table>
                @if (dataSucursales.length === 0) {
                  <div class="w3-row w3-center" style="margin-top: 3vh;">{{'proyFinanciera.configCatalogo.confVacia' | translate}}</div>
                }
                
              </div>
              <div class="w3-row">
                @if (dataSucursales.length !== 0 && newSucursales) {
                  <div class="w3-right">
                    <button mat-flat-button color="success" style="height: 3vh; width: 100%;" (click)="postDataSucursal()">{{'acciones.guard' | translate}}</button>
                  </div>
                }              
              </div>
            </div>   
          </mat-tab>
        }
      </mat-tab-group>
    </div>    
  </div>
</div>

<div id="nuevaPlantilla" class="w3-modal" (click)="clickFuera($event, 'nuevaPlantilla')">
  <div class="w3-modal-content w3-white" style="padding: 3vh; border-radius: 5px;">
    <div class="w3-row">
      <div class="w3-row w3-half w3-titulo-contenidomenuG padreizquierda" style="margin-left: 30px; margin-top: 18px;">
        {{tituloModal}}
      </div>
      <div class="w3-rest">
        <mat-icon (click)="closeModal('nuevaPlantilla')" matTooltip="{{ 'gestion.seguimiento.estrategias.cerrar' | translate }}" class="w3-button w3-display-topright"
          style="margin-top: 18px;margin-right: 24px;">clear</mat-icon>
      </div>
    </div>    
    <div class="w3-row w3-center " style="margin: 3vh;">
      <form [formGroup]="formPlantilla" (ngSubmit)="guardarPlantilla()">
        <div class="w3-row campoForm">
          <div class="w3-row w3-veinte  alinRight marginsH" style="margin-top: 2%;">{{'proyFinanciera.configCatalogo.nombre' | translate}}</div>
          <div class="w3-rest alinLeft">
            <mat-form-field appearance="outline" color="warn" class="field-input">
              <input matInput placeholder="Nombre" formControlName="nombre">
            </mat-form-field>
          </div>
        </div>
        
        <div class="w3-row campoForm">
          <div class="w3-row w3-veinte  alinRight marginsH" style="margin-top: 2%;">{{'proyFinanciera.configCatalogo.descrip' | translate}}</div>
          <div class="w3-rest alinLeft">
            <mat-form-field appearance="outline" color="warn" class="field-textArea">
              <textarea matInput placeholder="Descripción" style="resize: none;" formControlName="descrip"></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="w3-row campoForm">
          <div class="w3-row w3-veinte  alinRight marginsH" style="margin-top: 2%;">{{'proyFinanciera.configCatalogo.institucion' | translate}}</div>
          <div class="w3-rest alinLeft">
            <mat-form-field appearance="outline" color="warn" class="field-input">
              <mat-select formControlName="institucion" placeholder="{{'proyFinanciera.configCatalogo.selecInst' | translate}}">
                @for (g of inst; track $index) {
                  <mat-option [value]="g.id">{{g.nombre}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="w3-row w3-center" style="margin-top: 4vh;">
          <button mat-flat-button color="success" style="height: 5vh; width: 30%;" [disabled]="formPlantilla.invalid" [ngClass]="{'w3-disabled': formPlantilla.invalid}">{{'acciones.guard' | translate}}</button>
        </div>
      </form>
    </div>
  </div>

</div>
<div id="nuevaValidacion" class="w3-modal" (click)="clickFuera($event, 'nuevaValidacion')">
  <div class="w3-modal-content w3-white" style="padding: 3vh; border-radius: 5px;">
    <div class="w3-row">
      <div class="w3-row w3-half w3-titulo-contenidomenuG padreizquierda" style="margin-left: 30px; margin-top: 18px;">
        {{tituloModal}}
      </div>
      <div class="w3-rest">
        <mat-icon (click)="closeModal('nuevaValidacion')" matTooltip="{{ 'gestion.seguimiento.estrategias.cerrar' | translate }}" class="w3-button w3-display-topright"
          style="margin-top: 18px; margin-right: 24px;">clear</mat-icon>
      </div>
    </div>    
    <div class="w3-row w3-center " style="margin: 3vh;">
      <form [formGroup]="formValidacion" (ngSubmit)="guardarValidacion()">
        <div class="w3-row campoForm">
          <div class="w3-row w3-veinte alinRight marginsH" style="margin-top: 2%;">{{'proyFinanciera.configCatalogo.nombre' | translate}}</div>
          <div class="w3-rest alinLeft">
            <mat-form-field appearance="outline" color="warn" class="field-input">
              <input matInput placeholder="Nombre" formControlName="nombre">
            </mat-form-field>
          </div>
        </div>
        
        <div class="w3-row campoForm">
          <div class="w3-row w3-veinte alinRight marginsH" style="margin-top: 2%; margin-bottom: 2%;">{{'proyFinanciera.configCatalogo.expresion' | translate}}</div>
          <div class="w3-rest alinLeft">
            <mat-form-field appearance="outline" color="warn" class="field-input">
              <input matInput id="numerador" type="text" formControlName="expresion" placeholder="{{'proyFinanciera.configIndicador.ejNum' | translate}}"/>
            </mat-form-field>
            <!-- Mensajes de error -->
            @if (formValidacion.get('expresion')?.errors; as errors) {
              <div class="text-red-500 text-sm mt-1">
                @switch (true) {
                  @case (errors['invalidCharacter']) {
                    {{ 'proyFinanciera.configIndicador.caracterInv' | translate }}
                  }
                  @case (errors['unbalancedParentheses']) {
                    {{ 'proyFinanciera.configIndicador.noParentesis' | translate }}
                  }
                  @case (errors['invalidOperatorSequence']) {
                    {{ 'proyFinanciera.configIndicador.secuenciaInv' | translate }}
                  }
                }
              </div>
            }
            @if (formValidacion.get('expresion')?.errors?.['codigoInvalido']; as errores) {
              <div class="text-red-500 text-sm mt-1">
                {{'proyFinanciera.configIndicador.cuentasInv' | translate}} {{ errores.join(', ') }}
              </div>
            }
          </div>
        </div>
        <div class="w3-row w3-center" style="margin-top: 5vh;">
          <button mat-flat-button color="success" style="height: 5vh; width: 30%;" [disabled]="formValidacion.invalid" [ngClass]="{'w3-disabled': formValidacion.invalid}">{{'acciones.guard' | translate}}</button>
        </div>
      </form>
    </div>
  </div>

</div>